import {NEW_ID} from '../../../../common/constants/index.js'
import ButtonPrimary from '../../../../common/components/Button/ButtonPrimary.js'
import ButtonSecondary from '../../../../common/components/Button/ButtonSecondary.js'
import Archive from './Archive.js'
import Nickname from './Nickname.js'
import ShippingMethods from './ShippingMethods.js'
import {
  formSelector,
  getState,
  onlyIfAutoForm,
  useSelector,
} from '../../../../store.js'
import {redirect} from '../../../../common/location.js'
import {CANADA_POST} from '../../../../common/constants/ShipperNames.js'
import {
  baseShipperFormErrorsSelector,
  baseShipperInitialFormSelector,
  goToShipperSettings,
  simpleSaveShipper,
} from '../ShippersFunctions.js'

export function setUpShipperForm({shipper, formName}) {
  return {
    formName,
    initialForm: {
      ...initialFormSelector(getState(), {shipper}),
      errorsSelector,
    },
  }
}

export function errorsSelector(state, {formName}) {
  return baseShipperFormErrorsSelector(state, {formName})
}

export function initialFormSelector(state, {shipper}) {
  return baseShipperInitialFormSelector(state, {shipper, vendor: CANADA_POST})
}

export function authorize(formName) {
  const {id} = formSelector(getState(), {formName})

  const params = {
    shipperID: id && id !== NEW_ID ? id : undefined,
  }

  return redirect(null, ['verde', 'canada_post', 'start'], params)
}

export async function saveShipperCanadaPost(formName) {
  return simpleSaveShipper(formName)
}

function CanadaPostForm({formName, form}) {
  const errors = useSelector((state) => form.errorsSelector(state, {formName}))

  return (
    <div className="settings-list-item-form-wrap settings-list-item-form-cp clear-both">
      <div className="medium-6 columns">
        {form.id !== NEW_ID && (
          <fieldset>
            <ul className="form-list">
              <Nickname formName={formName} />
              <ShippingMethods formName={formName} />
              <li className="list__item list__item--no-style padding-bottom-20 divider--bottom">
                <ButtonPrimary
                  className="btn--primary-alt"
                  isLoading={form.isSaving}
                  isDisabled={errors.preventSave}
                  onClick={() => saveShipperCanadaPost(formName)}
                >
                  Update
                </ButtonPrimary>
              </li>
            </ul>
          </fieldset>
        )}
        <fieldset>
          <ul className="form-list">
            <li className="form-list-item helper-li">
              You will be directed to the Canada Post admin to authorize Ordoro
              to use your Canada Post account to print shipping labels.
            </li>
            <li className="form-list-item margin-top-20">
              <ButtonPrimary onClick={() => authorize(formName)}>
                {form.id !== NEW_ID ? 'Reauthorize' : 'Authorize'}
              </ButtonPrimary>
              <ButtonSecondary onClick={() => goToShipperSettings()}>
                Cancel
              </ButtonSecondary>
            </li>
          </ul>
        </fieldset>
      </div>

      {form.id !== NEW_ID && (
        <div className="medium-5 columns">
          <div className="alert margin-bottom-10 alert--standard">
            <Archive formName={formName} />
          </div>
        </div>
      )}
    </div>
  )
}

export default onlyIfAutoForm(CanadaPostForm, setUpShipperForm)
